// Booking/Trip Status Constants for FusionCab - Backend Compatible
// Unifies the two divergent status sets previously declared separately for
// CreateBookingPayload ("confirmed") and Booking ("assigned" | "ongoing").

export const BOOKING_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  ASSIGNED: "assigned",
  ONGOING: "ongoing",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

export type BookingStatus = (typeof BOOKING_STATUS)[keyof typeof BOOKING_STATUS];

export const TRIP_STATUS = {
  NOT_STARTED: "not_started",
  STARTED: "started",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

export type TripStatus = (typeof TRIP_STATUS)[keyof typeof TRIP_STATUS];
